import React from 'react'
import { Styled } from './MenuMobile.styled'
import NavItems from 'components/NavItems/NavItems'
import NavItemsPrivate from 'components/NavItems/NavItemsPrivate'
import NavbarProfile from 'components/NavbarProfile/NavbarProfile'
import NavbarProfilePrivate from 'components/NavbarProfile/NavbarProfilePrivate'
import arrowMobile from 'assets/images/ico/close.png'
import pushDataLayerGTM from 'util/pushDataLayerGTM'

const isLoggedIn = () => {
  return localStorage.getItem('auth-token')
}

const MenuMobile = ({ open, setMenuOpen, ...props }) => {
  const handleCloseMenu = () => {
    // Taguamento GTM para fechamento do menu mobile
    const category = 'geral'
    const action = 'clique:header'
    const label = 'fechar-menu-mobile'
    const additionalData = { position: 'header' }
    pushDataLayerGTM(category, action, label, additionalData)
    setMenuOpen()
  }

  return (
    <Styled.Wrap open={open}>
      <Styled.CloseMenu onClick={handleCloseMenu}>
        <img src={arrowMobile} alt="" width={'32px'} />
      </Styled.CloseMenu>
      <hr />
      <Styled.Pad>
        {isLoggedIn() ? (
          <NavbarProfilePrivate
            infoUsuario={props.infoUsuario}
            loadInfo={props.loadInfo}
          />
        ) : (
          <NavbarProfile mobile />
        )}
      </Styled.Pad>

      {isLoggedIn() ? (
        <NavItemsPrivate
          CloseMenu={setMenuOpen}
          isPerson={props.isPerson}
          checkDocumentValidation={props.checkDocumentValidation}
        />
      ) : (
        <>
          <hr />
          <NavItems CloseMenu={setMenuOpen} />
        </>
      )}
    </Styled.Wrap>
  )
}

export default MenuMobile
